/** A Raging Berserker's heartbeat, shared by the flush on the skin (`berserker-effects.ts`) and the thump heard (`combat-sounds.ts`) so they beat together. */
export const RAGE_PULSE = {
  /** Beats a second: quicker with each Fury Die held. */
  rate: (dice: number) => 1.1 + dice * .35,
  /** Keeps two Berserkers out of step. */
  seed: (id: string) => id.length * 1.7 + id.charCodeAt(0) * .13,
  /** Where in a beat (0–1) the first thump lands. */
  thump: .05,
} as const;

/** How far into its beat (0–1) a hero's pulse is at `time`. */
export const rageBeat = (time: number, dice: number, id: string) => (time * RAGE_PULSE.rate(dice) + RAGE_PULSE.seed(id)) % 1;
